import { render } from "./InvestProjects.vue?vue&type=template&id=6dffed12&scoped=true"
import script from "./InvestProjects.vue?vue&type=script&lang=js"
export * from "./InvestProjects.vue?vue&type=script&lang=js"

import "./InvestProjects.vue?vue&type=style&index=0&id=6dffed12&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dffed12"]])

export default __exports__